import { fullScreenAtom } from "@/shared/atoms";
import { useSetLayout } from "@/shared/atoms/useLayout";
import { setKioskModeSafe } from "@/shared/utils/electronKioskMode";
import { useSetAtom } from "jotai";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const useKioskSetup = () => {
  const setLayout = useSetLayout();
  const setFullScreen = useSetAtom(fullScreenAtom);
  const { pathname } = useLocation();
  const wasKioskRef = useRef(pathname.startsWith("/kiosk"));

  useEffect(() => {
    const isKiosk = pathname.startsWith("/kiosk");

    if (isKiosk) {
      setLayout({ mt: "0", showFullscreen: false });
      setFullScreen(true);
      setKioskModeSafe(true);
    } else {
      setKioskModeSafe(false);
      // Only reset layout/fullscreen when leaving kiosk — don't fight Mimic / nav fullscreen
      if (wasKioskRef.current) {
        setLayout({ mt: "mt-4", showFullscreen: true });
        setFullScreen(false);
      }
    }

    wasKioskRef.current = isKiosk;
  }, [pathname, setLayout, setFullScreen]);
};

export default useKioskSetup;
